<script lang="ts">
	import { page } from '$app/stores';

	$: parts = new URL($page.url).pathname.substring(1).split('/').slice(0, -1);

	function recursive(index: number): string {
		return '/' + parts.slice(0, index + 1).join('/');
	}
</script>

<div class="not-prose text-sm breadcrumbs z-40 {$$props.class}">
	<ul>
		{#each parts as part, index}
			<li>
				<a class="capitalize" href={recursive(index)}>{part}</a>
			</li>
		{/each}
	</ul>
</div>
